import type { CrossPlatformPackage } from "../../../shared/hooks/useRevenueCat";

interface PaywallPricingCardProps {
    pricingPackage: CrossPlatformPackage;
    paywallShowPerMonthMode?: boolean;
    isSelected?: boolean;
    onClick?: () => void;
}

export const PaywallPricingCard: React.FC<PaywallPricingCardProps> = ({
    pricingPackage,
    paywallShowPerMonthMode = false,
    isSelected = false,
    onClick,
}) => {
    return (
        <div className="flex flex-col items-center gap-1 flex-1">
            <div className="relative w-full">
                {pricingPackage.cardBadgeText && (
                    <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 z-10">
                        <div className="bg-pink-mascotte text-osBlack text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap">
                            {pricingPackage.cardBadgeText}
                        </div>
                    </div>
                )}
                {isSelected && (
                    <div className="absolute top-3 right-3 z-10">
                        <div className="bg-osBlack rounded-full w-6 h-6 flex items-center justify-center">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 3L4.5 8.5L2 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </div>
                )}
                <div
                    className={`bg-osGrey-5 rounded-[24px] px-3 py-5 flex flex-col w-full border-2 ${onClick ? 'cursor-pointer' : ''} ${isSelected ? 'border-osBlack' : 'border-transparent'}`}
                    onClick={onClick}
                >
                    <h4 className='text-center text-osBlack font-semibold'>
                        {pricingPackage.displayTitle}
                    </h4>
                    <h4 className='text-center text-osBlack text-lg font-semibold leading-tight'>
                        {paywallShowPerMonthMode ?
                            <>{pricingPackage.pricePerMonthString}<wbr /><span className="text-sm">/month</span></>
                            : <>{pricingPackage.formattedPrice}<wbr /><span className="text-sm">/{pricingPackage.billingPeriodNoun}</span></>}
                    </h4>
                </div>
            </div>
            <p className={`text-sm ${isSelected ? 'text-osBlack font-semibold' : 'text-osGrey-2'}`}>
                {paywallShowPerMonthMode ?
                    `billed ${pricingPackage.billingPeriod} at ${pricingPackage.formattedPrice}` :
                    `billed ${pricingPackage.billingPeriod}`
                }
            </p>
        </div>
    );
};